import Title from "../Title/Title";
import ServiceCard from "./ServiceCard";
import styles from "./Services.module.css";

function Services({ title, services, tick }) {
  return (
    <section className={styles.services}>
      <Title titleText={title} />

      <div className="container rtl">
        <div className="row gx-2 gy-5 justify-content-center">
          {services.map(service => (
            <div key={service.id} className="col-12 col-sm-6 col-lg-3">
              <ServiceCard key={`services-${service.id}`} {...service} tick={tick} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;
